import React from "react";
import classNames from "classnames";
import { Typography } from "@mui/material";
import styles from "./styles";

const ContentHeader = (props) => {
  const _ponytailDefaults = {
  title: "",
  description: "",
  className: "",
};
  props = { ..._ponytailDefaults, ...props };

  const classes = styles();
  return (
    <div className={classNames(classes.header, props.className)}>
      <Typography variant="h6" className="font-weight-bold">
        {props.title}
      </Typography>
      <Typography
        style={{
          marginTop: 5,
          marginBottom: 15,
          width: "100%",
          fontSize: "0.9em",
        }}
        variant="body2" component="div"
        color="textSecondary"
      >
        {props.description}
      </Typography>
    </div>
  );
};


export default ContentHeader;
